import { createImportRetry } from '@shared-fe/utils/importRetry'
import newRelic from '@mortgage-pos/ui/services/newRelic'

export const importRetry = createImportRetry({
  trackMetric: (name) => newRelic.increment(name),
})
